module.exports = __webpack_public_path__ + "static/media/images-api-support.3e6e5184.svg";